module.exports = __webpack_public_path__ + "2da5b6305e466e6d1242116b10b73e1b.ttf";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Book.ttf
// module id = 650
// module chunks = 0